import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HeaderComponent } from '../components/header/header.component';
import { FooterComponent } from '../components/footer/footer.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { ModalComponent } from '../components/modal/modal.component';
import { LoadingSpinnerComponent } from '../components/loading-spinner/loading-spinner.component';
import { CourseBreadcrumbNavComponent } from '../components/course-breadcrumb-nav/course-breadcrumb-nav.component';
import { BypassSecurityPipe } from '../pipes/bypass-security.pipe';
import { RelativeUrlPipe } from '../pipes/relative-url.pipe';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ModalComponent,
    LoadingSpinnerComponent,
    CourseBreadcrumbNavComponent,
    BypassSecurityPipe,
    RelativeUrlPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ModalComponent,
    LoadingSpinnerComponent,
    CourseBreadcrumbNavComponent,
    BypassSecurityPipe,
    RelativeUrlPipe,
  ],
})
export class SharedModule {}
